import type { RouterConfig } from '@nuxt/schema'

export default {
  scrollBehavior(to, from, savedPosition) {
    const nuxtApp = useNuxtApp()
    const toName = normalizeRouteName(to.name)
    const fromName = normalizeRouteName(from.name)

    // NOTE: Don't change scroll position when navigating between product detail pages
    // We handle it manually for nicer user experience with animations.
    if (toName === 'product-detail' && toName === fromName) {
      return false
    }

    let scrollPosition: {
      top: number
      left: number
    } = {
      top: 0,
      left: 0,
    }

    // NOTE: if a saved position is available (e.g., when using the browser's back button), use it
    if (savedPosition) {
      scrollPosition = savedPosition
    }

    // NOTE: wait for the page to finish loading before scrolling to the top of the page
    // Important for the catalog, so the lazy loaded content is rendered before scrolling
    return new Promise((resolve) => {
      nuxtApp.hooks.hookOnce('page:finish', () => {
        nextTick(() => {
          resolve(scrollPosition)
        })
      })
    })
  },
} satisfies RouterConfig
